<template>
  <div class="member" style="min-width:1440px;">
    <div class="member_content">
      <div class="container animated fadeInUp">
        <h1 v-if="chOrEn!='0'" style="text-align:left;font-size:64px;width:650px;line-height: 96px;">雕塑园(馆)国际联盟</h1>
        <h1 v-if="chOrEn!='0'" style="margin-bottom:40px;text-align:left;font-size:64px;width:561px;line-height: 96px;">诚邀赞助!</h1>
        <h1 v-if="chOrEn=='0'" style="text-align:left;font-size:64px;line-height: 96px;width:900px;">International Sculpture Park(Gallery/Museum) Union </h1>
        <h1 v-if="chOrEn=='0'" style="margin-bottom:40px;text-align:left;font-size:64px;line-height: 96px;">accepts sponsorship!</h1>
        <h4 v-if="chOrEn!='0'">详细赞助形式及其他信息,请联络</h4>
        <h4 v-else>For detailed sponsorship forms and other information, please contact</h4>
        <h4 v-if="chOrEn!='0'">联盟秘书处: {{phone}} {{liaison}}</h4>
        <h4 v-else>Union Secretariat: {{phone}} {{liaison}}</h4>
      </div>
    </div>

  </div>
</template>

<script>

import {email} from '../api/api'
export default {
  name: "member",

  data() {
    return {
        chOrEn:sessionStorage.getItem('chOrEn'),
        phone:'',
        liaison:''
    };
  },
  created(){
    let navigationId = {
      "navigationId":"1"
    }
    email({...navigationId}).then(res=>{
      console.log(res)
      this.phone=res.data.data.telphone
      this.liaison=res.data.data.other
    })
  },
  
};
</script>

<style lang="less" scoped>
.member_content {
  width: 100%;
  height: 932px;
  background: url("../assets/img/chengyaozanzhu.png") no-repeat;
  background-size: 100% 100%;
  .container {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    height: 100%;
    flex-direction: column;
    font-size:18px;
    color:#FFFFFF;
    h1 {
      font-size: 36px;
      line-height: 50px;
      text-align: center;
    }
    h4 {
      text-align: center;
      color: #FFFFFF;
      font-size: 18px;
      line-height: 40px;
    }
    h5 {
      font-size: 18px;
      line-height: 40px;
    }
    .down_load {
      width: 118px;
      height: 118px;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 50%;
      margin-bottom: 20px;
      a {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        text-align: center;
        line-height: 100%;
        .iconfont {
          color: rgba(255, 255, 255, 0.7);
          font-size: 50px;
          line-height: 118px;
        }
      }
    }
  }
}
</style>